import { createClient } from '@supabase/supabase-js';

// Set these in .env: REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY
// Supabase Dashboard → Settings → API. Restart dev server after changing .env.
const supabaseUrl = (process.env.REACT_APP_SUPABASE_URL || '').trim();
const supabaseAnonKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

const isValidUrl = supabaseUrl.startsWith('http://') || supabaseUrl.startsWith('https://');
const isPlaceholder = !isValidUrl || !supabaseAnonKey;

if (isPlaceholder) {
  console.warn(
    '[Supabase] Using placeholder config — login will fail with NetworkError.\n' +
    '1. Add to .env: REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY\n' +
    '2. Restart the dev server (npm start)\n' +
    '3. Ensure Supabase project is not paused (Dashboard → Settings → General)'
  );
}

const url = isValidUrl ? supabaseUrl : 'https://placeholder.supabase.co';
const key = supabaseAnonKey || 'placeholder-key';

export const supabase = createClient(url, key);
export const isSupabaseConfigured = !isPlaceholder;
export const supabaseUrlForLog = isPlaceholder ? 'placeholder (not configured)' : url;
export const supabaseFunctionsUrl = isPlaceholder ? null : `${url}/functions/v1`;
export { key as supabaseAnonKey };

